import { render, staticRenderFns } from "./profileOwner.vue?vue&type=template&id=40ff27a4&scoped=true"
import script from "./profileOwner.vue?vue&type=script&lang=js"
export * from "./profileOwner.vue?vue&type=script&lang=js"
import style0 from "./profileOwner.vue?vue&type=style&index=0&id=40ff27a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff27a4",
  null
  
)

export default component.exports